import React from 'react';
import { LocalizationProvider, TimePicker, TimePickerProps } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const CustomTimePicker: React.FC<TimePickerProps<Date, Date>> = ({
    label,
    value,
    onChange,
    ampm,
    InputProps = {},
    renderInput,
    PopperProps,
}) => {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        label={label}
        value={value}
        onChange={onChange}
        ampm={ampm} // 24-hour format
        PopperProps={{
            ...PopperProps,
            sx: {
                ...PopperProps?.sx,
                '& .MuiPickersArrowSwitcher-root': {
                  position: 'absolute !important',
                  top: '15px !important',
                  right: '11px !important',
                  left: 'auto !important',
                },
                '& .MuiClock-root': {
                  transform: 'none !important',
                  transition: 'none !important',
                },
                '& .MuiClock-clock': {
                    transform: 'none !important',
                    transition: 'none !important',
                },
            },
        }}
       
        renderInput={renderInput}
      />
    </LocalizationProvider>
  );
};

export default CustomTimePicker;
